export enum CreditCardsPlan {
    FREE = 'Free',
    LIGHT = 'Light',
    PLUS = 'Plus',
}